import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const PreMediaDetailImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: 'pm_320_wm', width: 320, height: 213, ratio: 1.5 },
  { screen: Screen.XXS, key: 'pm_375_wm', width: 375, height: 250, ratio: 1.5 },
  { screen: Screen.XS, key: 'pm_400_wm', width: 400, height: 267, ratio: 1.5 },
  { screen: 450, key: 'pm_500_wm', width: 500, height: 333, ratio: 1.5 },
  { screen: Screen.SM, key: 'pm_568_wm', width: 568, height: 379, ratio: 1.5 },
  { screen: 600, key: 'pm_600_wm', width: 600, height: 400, ratio: 1.5 },
  { screen: Screen.MD, key: 'pm_768_wm', width: 768, height: 512, ratio: 1.5 },
  { screen: 900, key: 'pm_960_wm', width: 960, height: 640, ratio: 1.5 },
  { screen: Screen.LG, key: 'pm_1024_wm', width: 1024, height: 683, ratio: 1.5 },
  { screen: Screen.XL, key: 'pm_1600_wm', width: 1600, height: 1067, ratio: 1.5 },
];

export const PreMediaLightboxImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: 'pm_375_wm', width: 375, height: 250, ratio: 1.5 },
  { screen: Screen.XXS, key: 'pm_568_wm', width: 568, height: 379, ratio: 1.5 },
  { screen: Screen.XS, key: 'pm_768_wm', width: 768, height: 512, ratio: 1.5 },
  { screen: Screen.SM, key: 'pm_1024_wm', width: 1024, height: 683, ratio: 1.5 },
  { screen: Screen.LG, key: 'pm_1600_wm', width: 1600, height: 1067, ratio: 1.5 },
];
